import {ArgoContext} from "@awsscm/argo-core/argo";

interface metricDurationModel {
    metricName: string,
    startTimeStamp: number,
    isPaused: boolean,
    timeElapsed: number
}

export class KatalHelper {

    context: ArgoContext;

    durationMetricsOperationMap: Map<string, metricDurationModel>;

    constructor(context: ArgoContext) {
        this.context = context;
        this.durationMetricsOperationMap = new Map<string, metricDurationModel>();
    }


    startLatencyTimer(metricName: string, uuid: string): void {
        if (this.durationMetricsOperationMap.has(uuid)) {
            const metricModel: metricDurationModel = this.durationMetricsOperationMap.get(uuid)!;
            metricModel.startTimeStamp = Date.now();
            metricModel.isPaused = false;
        }
        else {
            this.durationMetricsOperationMap.set(uuid, {
                metricName: metricName,
                startTimeStamp: Date.now(),
                isPaused: false,
                timeElapsed: 0
            })
        }
    }

    pauseLatencyTimer(uuid: string): number {
        if (this.durationMetricsOperationMap.has(uuid)) {
            const metricModel: metricDurationModel = this.durationMetricsOperationMap.get(uuid)!;
            if (metricModel.isPaused) {
                return 0;
            }
            const startTime : number = metricModel.startTimeStamp;
            const timeElapsed: number =  metricModel.timeElapsed + Date.now() - startTime;
            metricModel.isPaused = true;
            metricModel.timeElapsed += timeElapsed

            return timeElapsed;
        }

        return 0;
    }

    removeAPIFromOperationMap(uuid: string): void {
        if (this.durationMetricsOperationMap.has(uuid)) {
            this.durationMetricsOperationMap.delete(uuid);
        }
    }

    endLatencyTimer(uuid: string): number {
        if (this.durationMetricsOperationMap.has(uuid)) {
            const metricModel: metricDurationModel = this.durationMetricsOperationMap.get(uuid)!;
            const startTime : number = metricModel.startTimeStamp;
            const prevTimeElapsed: number = metricModel.timeElapsed;
            const endTime: number = Date.now();
            const timeElapsed: number = prevTimeElapsed + (metricModel.isPaused ? 0 : (endTime - startTime));
            metricModel.timeElapsed = timeElapsed;
            metricModel.isPaused = true;
            return timeElapsed;
        }

        return 0;
    }


    emitLatencyMetrics(methodName: string, uuid: string) : void {
        const timeElapsed: number = this.endLatencyTimer(uuid);
        if (timeElapsed !== 0) {
            const metricName = this.durationMetricsOperationMap.get(uuid)!.metricName;
            this.emitCountMetrics(metricName + ":Latency", methodName, timeElapsed);
        }

    }

    emitCountMetrics(metricName: string, methodName: string, count: number) : void {
        const childPublisher = this.context.initialMetricsPublisher.newChildActionPublisherForMethod(methodName);
        childPublisher.publishCounterMonitor(metricName, count);
    }

    logInfo(message: string): void {
        this.context.logger.info(message);
    }

    logError(message: string): void {
        this.context.logger.error(message);
    }

}